import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: (navigator.language || "en").split("-")[0],
};

const localeSlice = createSlice({
  name: "locale",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const { setLanguage } = localeSlice.actions;
export default localeSlice.reducer;
